export const Storage_Keys = {
  AdminData: 'AdminData',
  authtoken: 'authtoken',
  loginVia: 'loginVia',
  pricingVersion: 'pricingVersion',
  catalogActiveVersion: 'catalogActiveVersion',
  roles: "roles",
}

export const Session_Storage_keys = {
  catalogVersion: 'catalogVersion',
  AdminData: 'AdminData',
  authtoken: 'authtoken',
  loginVia: 'loginVia',
  pricingVersion: 'pricingVersion',
  catalogActiveVersion: 'catalogActiveVersion',
  roles: "roles",
}
